function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2.74991C6.89137 2.74991 2.75 6.89127 2.75 11.9999C2.75 17.1085 6.89137 21.2499 12 21.2499C17.1086 21.2499 21.25 17.1085 21.25 11.9999C21.25 6.89127 17.1086 2.74991 12 2.74991ZM1.25 11.9999C1.25 6.06285 6.06294 1.24991 12 1.24991C17.9371 1.24991 22.75 6.06285 22.75 11.9999C22.75 17.937 17.9371 22.7499 12 22.7499C6.06294 22.7499 1.25 17.937 1.25 11.9999Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3002 7.77805C11.7765 7.68821 11.2379 7.78663 10.7798 8.05586C10.3217 8.32509 9.97363 8.74776 9.7973 9.24901C9.65985 9.63975 9.23166 9.84508 8.84092 9.70763C8.45018 9.57018 8.24485 9.14199 8.3823 8.75125C8.67618 7.91583 9.25624 7.21138 10.0197 6.76266C10.7832 6.31394 11.6809 6.14992 12.5538 6.29964C13.4266 6.44935 14.2183 6.90315 14.7886 7.58066C15.3589 8.2581 15.6711 9.1155 15.6698 10.001C15.6694 11.3987 14.631 12.3441 13.8358 12.8742C13.4154 13.1545 13.0002 13.3615 12.6932 13.498C12.5386 13.5667 12.4087 13.6187 12.3157 13.6541C12.2692 13.6719 12.2317 13.6855 12.2048 13.6951L12.1724 13.7064L12.1625 13.7098L12.1592 13.7109L12.1579 13.7113C12.1577 13.7114 12.157 13.7116 11.9198 13.0001L12.157 13.7116C11.764 13.8426 11.3393 13.6303 11.2083 13.2373C11.0774 12.8447 11.2893 12.4204 11.6815 12.289C11.6817 12.2889 11.6813 12.2891 11.6815 12.289L11.6844 12.288L11.7022 12.2817C11.7193 12.2757 11.7462 12.2659 11.7817 12.2524C11.8528 12.2253 11.9573 12.1836 12.0839 12.1273C12.3394 12.0137 12.6742 11.8458 13.0038 11.6261C13.7085 11.1563 14.1698 10.602 14.1698 10.0001L14.1698 9.99901C14.1706 9.46765 13.9833 8.95316 13.6411 8.54666C13.2989 8.14015 12.8239 7.86788 12.3002 7.77805Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 16.9999C11.25 16.5857 11.5858 16.2499 12 16.2499H12.01C12.4242 16.2499 12.76 16.5857 12.76 16.9999C12.76 17.4141 12.4242 17.7499 12.01 17.7499H12C11.5858 17.7499 11.25 17.4141 11.25 16.9999Z",
  fill: "currentColor"
});

function SvgHelpCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.50c4767e.svg";
export { ForwardRef as ReactComponent };